import { HubConnection } from '@microsoft/signalr';

export interface LeaderboardEntry {
  playerId: string;
  playerName: string;
  prestigeLevel: number;
  currentPrestigeScore: number;
  totalScoreAllTime: number;
  yieldPerSecond: number;
  lastUpdated: string;
}

export interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  lastUpdated: string;
}

export const fetchLeaderboard = async (connection: HubConnection): Promise<LeaderboardResponse> => {
  return await connection.invoke('GetLeaderboard');
};
